import { enqueueSnackbar, DownloadFile } from 'actions';
import {
	nrImportFileRequest, nrImportFileSuccess, nrImportFileFailure,
	nrGetLastResultRequest, nrGetLastResultSuccess, nrGetLastResultFailure,
	nrSendEmailRequest, nrSendEmailSuccess, nrSendEmailFailure,
	nrGetLastUpdateRequest, nrGetLastUpdateSuccess, nrGetLastUpdateFailure,
} from './naspReportingActions';
import {
	NaspReportingImportFileRequest,
	NaspReportingGetLastResultRequest,
	NaspReportingSendEmailRequest,
	NaspReportingGetLastUpdateRequest,
} from '../requests/naspReportingRequests';

// ─── NASP REPORTING ───────────────────────────────────────────────────────────

const pickLastUpdate = (raw) => ({
	user:      raw?.insertUser ?? raw?.InsertUser ?? null,
	timestamp: raw?.insertDate ?? raw?.InsertDate ?? null,
});

// Same output as the import, without an input file: the API answers with the
// path of the generated file, which is then handed to the user.
export const nrGetLastResult = (userId, report) => async (dispatch) => {
	dispatch(nrGetLastResultRequest(report));
	await NaspReportingGetLastResultRequest(userId, report).then((response) => {
		const filePath = response.data;
		dispatch(nrGetLastResultSuccess(report, filePath));
		if (typeof filePath === 'string' && filePath.trim() !== '') {
			dispatch(DownloadFile(filePath));
		} else {
			dispatch(enqueueSnackbar({ message: 'No result available yet.', options: { variant: 'warning' } }));
		}
	}).catch((error) => {
		dispatch(nrGetLastResultFailure(report, error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

// Sends the report by email — no file comes back.
// isTest true → test recipients; false → client distribution list.
// userEmail is who asked for it, so the BE can address the test email.
export const nrSendEmail = (userId, userEmail, report, isTest = true) => async (dispatch) => {
	dispatch(nrSendEmailRequest(report));
	await NaspReportingSendEmailRequest(userId, userEmail, report, isTest).then((response) => {
		dispatch(nrSendEmailSuccess(report, response.data));
		dispatch(enqueueSnackbar({
			message: isTest ? 'Test email sent successfully.' : 'Email sent to the client.',
			options: { variant: 'success' },
		}));
	}).catch((error) => {
		dispatch(nrSendEmailFailure(report, error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

export const nrGetLastUpdate = () => async (dispatch) => {
	dispatch(nrGetLastUpdateRequest());
	await NaspReportingGetLastUpdateRequest().then((response) => {
		const data = response.data ?? {};
		dispatch(nrGetLastUpdateSuccess({
			ThreeMonthComparison: pickLastUpdate(data.threeMonthComparison ?? data.ThreeMonthComparison),
			Cancellations:        pickLastUpdate(data.cancellations ?? data.Cancellations),
		}));
	}).catch((error) => {
		dispatch(nrGetLastUpdateFailure(error?.message));
	});
};

// report: 'ThreeMonthComparison' | 'Cancellations'
// The API answers with the path of the generated file, which is then fetched
// through File/Download and handed to the user.
export const nrImportFile = (userId, report, file) => async (dispatch) => {
	dispatch(nrImportFileRequest(report));
	await NaspReportingImportFileRequest(userId, report, file).then((response) => {
		const filePath = response.data;
		dispatch(nrImportFileSuccess(report, filePath));
		if (typeof filePath === 'string' && filePath.trim() !== '') {
			dispatch(DownloadFile(filePath));
		}
		dispatch(enqueueSnackbar({ message: 'File imported successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(nrImportFileFailure(report, error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};
